export default __webpack_public_path__ + "static/media/services_03.585382f7.jpg";